module.exports = __webpack_public_path__ + "img/20180815_154807_251.e48ea65b.jpg";